import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({ errorInfo });
    console.error('Error Boundary caught:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '40px',
          textAlign: 'center',
          fontFamily: 'Cairo, Arial, sans-serif',
          direction: 'rtl',
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#f8f9fa'
        }}>
          <div style={{
            background: 'white',
            borderRadius: '16px',
            padding: '40px',
            maxWidth: '500px',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
          }}>
            <h2 style={{ color: '#e74c3c', marginBottom: '20px' }}>
              حدث خطأ غير متوقع
            </h2>
            <p style={{ color: '#666', marginBottom: '20px' }}>
              حدث خطأ أثناء تحميل الصفحة. يرجى تحديث الصفحة أو المحاولة مرة أخرى.
            </p>
            <button
              onClick={() => window.location.reload()}
              style={{
                background: '#62a8e5',
                color: 'white',
                border: 'none',
                padding: '12px 30px',
                borderRadius: '8px',
                fontSize: '16px',
                cursor: 'pointer',
                fontFamily: 'Cairo, Arial, sans-serif'
              }}
            >
              تحديث الصفحة
            </button>
            {this.state.error && (
              <details style={{ marginTop: '20px', textAlign: 'left', direction: 'ltr' }}>
                <summary style={{ cursor: 'pointer', color: '#999' }}>Error Details</summary>
                <pre style={{
                  background: '#f1f1f1',
                  padding: '10px',
                  borderRadius: '8px',
                  overflow: 'auto',
                  fontSize: '12px',
                  marginTop: '10px',
                  maxHeight: '200px'
                }}>
                  {this.state.error.toString()}
                  {this.state.errorInfo && this.state.errorInfo.componentStack}
                </pre>
              </details>
            )}
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
